import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import axios from 'axios'

import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import HasPermission from '../../common/Permissions/HasPermission'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'

class StoreDetailsList extends React.Component {
  state = {
    storeDetails: [],
    order: 0,
    isEditing: false,
    keyword: '',
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
    isloading: false,
    sortField: '',
    sortOrder: '',
  }
  componentDidMount() {
    this.StoreDetailsList()
  }

  StoreDetailsList = async () => {
    this.setState({
      isloading: true,
      storeDetails: [],
    })

    await axios
      .get(Constant.getAPI() + '/store/list-stores', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          keyword: this.state.keyword,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          sortField: this.state.sortField,
          sortOrder: this.state.sortOrder,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            storeDetails: res.data.data,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
            disabled: this.state?.pageNumber + 1 >= res?.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isloading: false,
        })
      })
  }
  handleStatusChange = async (id, isActive) => {
    var data = {
      cat_id: id,
      is_active: isActive,
    }

    await axios
      .post(Constant.getAPI() + '/store/update-store-details', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.StoreDetailsList()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  onEdit = (selectedId, order) => {
    this.setState({ isEditing: true, selectedId, order })
  }
  onChangeSort = (selectedId) => {
    this.setState({ isEditing: false })

    var data = {
      id: selectedId,
      order: parseInt(this.state.order),
    }
    axios
      .post(Constant.getAPI() + '/store/update-store-priority', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.StoreDetailsList()
      })
      .catch(() => { })
  }
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.StoreDetailsList()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.StoreDetailsList()
      }
    )
  }

  render() {
    var LocalData = localStorage.getItem('loged_In_role')

    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'id',
        label: 'ID',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'shop_img',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (user_profile) => {
            return (
              <div>
                {user_profile !== null ? (
                  <img
                    src={user_profile ? Constant.getImage() + user_profile : './assets/images/no_image.png'}
                    className="img-fluid img-40"
                    alt="tbl"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                ) : (
                  <img
                    src={user_profile ? Constant.getImage() + user_profile : './assets/images/no_image.png'}
                    className="img-fluid img-40"
                    alt="tbl"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[0]
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isEditing ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order === null ? 0 : order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order === null ? 0 : order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isEditing ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeSort.bind(this, id)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order)}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'shop_name_en',
        label: 'Shop Name: English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'shop_name_ar',
        label: 'Shop Name: Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'shop_min_hour',
        label: 'Minimum Hours',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'minimum_order_amount',
        label: 'Minimum Order Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'shop_start_time',
        label: 'Shop Start Time',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'shop_end_time',
        label: 'Shop End Time',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'shop_type',
        label: 'Shop Type',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'store_commission',
        label: 'Store Commision',
        options: {
          filter: true,
          sort: true,
          display: localStorage?.getItem('loged_In_role') === 'store' ? false : true,
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={'is_active' + tableMeta.rowData[0]}
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !is_active)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Store Products',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <Link
                to={`/store-products/` + id}
                className="m-r-15 text-muted"
                data-toggle="tooltip"
                data-placement="top"
                title="View Store Products"
                data-original-title="View Store Products"
              >
                <i className="f-30 icofont icofont-box text-custom"></i>
              </Link>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Block Dates',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <Link
                to={`/store-details/${id}/store-block-date-lists`}
                className="m-r-15 text-muted"
                data-toggle="tooltip"
                data-placement="top"
                title="View Block Dates"
                data-original-title="View Block Dates"
              >
                <i className="f-30 icofont icofont-calendar text-custom"></i>
              </Link>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Contract Files',
        options: {
          filter: false,
          sort: false,
          display: HasPermission('contract-files'),
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/contract-files/store/${id}`}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="View Contract Files"
                  data-original-title="View Contract Files"
                >
                  <i className="f-30 icofont icofont-file-document text-custom"></i>
                </Link>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex justify-content-end align-items-center">
                <Link
                  to={`/store-details/add/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      search: true,
      filter: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      onColumnSortChange: (changedColumn, direction) => {
        this.setState(
          {
            sortField: changedColumn,
            sortOrder: direction,
            pageNumber: 0,
          },
          () => this.StoreDetailsList()
        )
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.StoreDetailsList()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.StoreDetailsList()
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.isloading ? <Loader open={this.state.isloading} /> : 'Sorry, No Store Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Store List</h4>
                    </div>
                  </div>
                  {LocalData === 'store' ? (
                    ''
                  ) : (
                    <Link
                      to="/store-details/add"
                      className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                      data-modal="modal-13"
                    >
                      {' '}
                      <i className="icofont icofont-plus m-r-5"></i> Add Store
                    </Link>
                  )}
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Store List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Store List'}
                          className="table-responsive"
                          data={this.state.storeDetails}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default StoreDetailsList
